import React, { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
const ComponentsDashboard = lazy(() => import('../containers/Components/ComponentsDashboard'));
const ComponentDetailsPage = lazy(() => import('../containers/Components/ComponentDetails/ComponentDetailsPage'));
function ComponentsRouts({ url }) {
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: `${url}/details/:componentId` },
            React.createElement(ComponentDetailsPage, null)),
        React.createElement(Route, { path: url },
            React.createElement(ComponentsDashboard, { url: url }))));
}
export default ComponentsRouts;
